import React, { useMemo } from 'react'
import {
    WaveMoneyIcon,
    CheckIcon,
    CircleCrossIcon,
    FilledPendingIcon
} from 'assets'
import { numberFormatter } from 'helpers/numberFormatter'
import './PaymentFeedbackMessage.scss'
import { Button } from 'components'
import { constants } from 'helpers/constants'

type PaymentFeedbackMessageProps = {
    amount: number
    status?: string
    t: (key: string) => string
    continueHandler?: () => void
    retryHandler?: () => void
    showRetryButton?: boolean
}

export const PaymentFeedbackMessage = ({
    amount,
    status,
    t,
    continueHandler,
    retryHandler,
    showRetryButton = true
}: PaymentFeedbackMessageProps) => {
    const feedbackIcons = useMemo(
        () => ({
            [constants.MOBILE_MONEY.SUCCESS]: (
                <CheckIcon width="50" height="50" />
            ),
            [constants.MOBILE_MONEY.FAILURE]: <CircleCrossIcon size="50" />,
            [constants.MOBILE_MONEY.PENDING]: <FilledPendingIcon size="50" />
        }),
        [status]
    )

    const titles = useMemo(
        () => ({
            [constants.MOBILE_MONEY.SUCCESS]: t(
                'paymentFeedback.paymentSuccessful'
            ),
            [constants.MOBILE_MONEY.FAILURE]: t(
                'paymentFeedback.paymentFailed'
            ),
            [constants.MOBILE_MONEY.PENDING]: t(
                'paymentFeedback.mobilePaymentPending'
            )
        }),
        [status]
    )

    return (
        <div className="payment-success-container">
            <div className="success-title-section">
                <div className={`${status}-title`}>
                    {status && titles[status]}
                </div>
            </div>

            <div className="icons-section">
                {status && feedbackIcons[status]}
                <WaveMoneyIcon size={50} />
            </div>

            <div className="amount-section">
                <div
                    className={`amount-${status}`}
                    aria-label={`amount-display-${status}`}
                >
                    {numberFormatter(amount)}
                </div>
            </div>
            {status === constants.MOBILE_MONEY.PENDING && (
                <div className="buttons-section">
                    <Button style="primary" onClick={continueHandler}>
                        {t('paymentFeedback.finish')}
                    </Button>
                </div>
            )}
            {status === constants.MOBILE_MONEY.FAILURE && showRetryButton && (
                <div>
                    <div className="buttons-section">
                        <Button style="outline" onClick={retryHandler}>
                            {t('paymentFeedback.retry')}
                        </Button>
                        <Button style="primary" onClick={continueHandler}>
                            {t('paymentFeedback.continue')}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    )
}
